import CableController from './cable_controller';

// function extractNode(html) {
//   const wrapper = window.document.createElement('table');
//   wrapper.innerHTML = html;
//   return wrapper.querySelector('tr');
// }

// function makeVisible(node) {
//   if (!node) return;

//   node.classList.toggle('flash-green-fade-once', true);
//   window.setInterval(() => {
//     if (!node) return;

//     node.classList.toggle('flash-green-fade-once', false);
//   }, 5000);
// }

export default class extends CableController {
  static targets = ['output', 'status', 'next_action'];

  received(data) {
    if (this.hasStatusTarget && data.text) {
      this.statusTarget.textContent = data.text;
    }

    if (this.hasOutputTarget && data.body) {
      const container = this.containerFor(data.key);
      const node = extractNode(data.body);
      if (container) container.innerHTML = node.innerHTML;
      else this.appendAfterOutputHeader(node);
      makeVisible(container);
    }
  }

  get outputHeader() {
    return this.outputTarget.querySelector('tr');
  }

  appendAfterOutputHeader(node) {
    if (this.outputHeader) {
      this.outputHeader.after(node);
    } else {
      this.outputTarget.appendChild(node);
    }
  }

  get channel() {
    return super.channel || 'ContractInsuranceChannel';
  }

  containerFor(id) {
    const key = `property_contract_container_${id}`;
    const keyQuery = `.${key}`;
    return this.outputTarget.querySelector(keyQuery);
  }
}
